import React from "react";
import { INSURANCE_CALCULATOR } from "../../../../../../../../common-deprecated/constants";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../../redux/store";
import Icon from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import FinanceInsuranceCalculatorLink from "../../../../../utils/FinanceInsuranceCalculatorLink";
import * as Styles from "./styles/InsuranceDetailsStyles";
import { clearInsuranceRate } from "../../../../../redux/actions/FinanceInsuranceActions";
import { BnbLabel } from "../../../../../utils/labels";
import InsurancePrice from "../../price/InsurancePrice";
import { NavOrigin } from "../../../../../../shared-logic/utils/Navigation";
import { useFinanceInsuranceNavigation } from "../../../../../hooks/shared/useFinanceInsurance";
import ButtonCta, { CtaIcon } from "../../../../../../../../common-deprecated/components/aem/lexus/button/ButtonCta";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const InsuranceDetails = (): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const isPersonalizedQuote = useBnbSelector((state) => state.insuranceRate.isPersonalizedQuote);
    const { showFinanceInsuranceInPage, enableFinanceCompare } = useBnbSelector((state) => state.bnbSettings);

    const step = useBnbSelector((state) => state.navigation.step);
    const { onClick: onInsuranceClick, insuranceLabelKey } = useFinanceInsuranceNavigation(step);

    return (
        <>
            <Styles.Title>
                <BnbLabel label="basketInsuranceTitle" />
            </Styles.Title>
            <Styles.Description>
                <BnbLabel label="basketInsuranceDescription" />
            </Styles.Description>
            {isPersonalizedQuote && (
                <Styles.Card>
                    <Styles.CardHeader>
                        <Styles.Title noBorder>
                            <BnbLabel label="insuranceTitle" />
                        </Styles.Title>
                        <Styles.RemoveButton
                            type="button"
                            onClick={(event) => {
                                event.preventDefault();
                                dispatch(clearInsuranceRate());
                            }}
                        >
                            <Icon variant="close" />
                        </Styles.RemoveButton>
                    </Styles.CardHeader>
                    <Styles.Description>
                        <InsurancePrice />
                    </Styles.Description>
                </Styles.Card>
            )}
            {!showFinanceInsuranceInPage && !enableFinanceCompare && (
                <FinanceInsuranceCalculatorLink
                    type={INSURANCE_CALCULATOR}
                    customButton={(props) => (
                        <ButtonCta onClick={() => props.onClick()} iconVariant={CtaIcon.Insurance}>
                            <BnbLabel label={props.label} />
                        </ButtonCta>
                    )}
                />
            )}
            {(showFinanceInsuranceInPage || enableFinanceCompare) && !isPersonalizedQuote && (
                <FinanceInsuranceCalculatorLink
                    type={INSURANCE_CALCULATOR}
                    customButton={() => (
                        <ButtonCta
                            onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                                onInsuranceClick(event, "cc-panel", NavOrigin.InsuranceCta);
                            }}
                            iconVariant={CtaIcon.Insurance}
                        >
                            <BnbLabel label={insuranceLabelKey} />
                        </ButtonCta>
                    )}
                />
            )}
        </>
    );
};

export default InsuranceDetails;
